import React from 'react'
import NotFound from './notfound'

const NotFoundEn = () => {
    return <NotFound languageCode="en" />
}

export default NotFoundEn
